module.exports = __webpack_public_path__ + "static/media/bigwinning_icon.415ff201.svg";